<template>
  <!-- 合作商家区域 -->
  <section class="partners-section">
    <div class="container">
      <p class="text-center mb-4">超過 10000 個商家選用 UUPay 服務</p>
      <!-- <div class="row justify-content-around">
        <div class="col-auto d-flex align-items-center">
          <img src="@/assets/uupay/images/yijia_log.png" alt="partner-img" class="partner-icon" style="height: 50px;">
        </div>
        <div class="col-auto">
          <img src="@/assets/uupay/images/rice_line_logo.png" alt="partner-img" class="partner-icon">
        </div>
        <div class="col-auto">
          <img src="@/assets/uupay/images/meet_nuddle_logo.png" alt="partner-img" class="partner-icon">
        </div>
        <div class="col-auto">
          <img src="@/assets/uupay/images/three_bro_logo.png" alt="partner-img" class="partner-icon">
        </div>
        <div class="col-auto">
          <img src="@/assets/uupay/images/hua_yu_jie_logo.png" alt="partner-img" class="partner-icon">
        </div>
        <div class="col-auto">
          <img src="@/assets/uupay/images/tai_xing_logo.png" alt="partner-img" class="partner-icon">
        </div>
        <div class="col-auto">
          <img src="@/assets/uupay/images/lips_tea_logo.png" alt="partner-img" class="partner-icon">
        </div>
      </div> -->
      <div class="row">
        <div class="horizontal-swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in items" :key="index">
              <div class="slide-content">
                <img :src="item.imgSrc" class="partner-icon" style="height: 50px;" v-if="index == 0">
                <img :src="item.imgSrc" class="partner-icon" v-else>
              </div>
            </div>
          </div>
          <!-- 分页器 -->
          <div class="swiper-pagination"></div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Swiper, { Navigation, Pagination } from 'swiper'

export default {
  name: 'UUPayMerchant',
  data() {
    return {
      items: [
        { imgSrc: require('@/assets/uupay/images/yijia_log.png') },
        { imgSrc: require('@/assets/uupay/images/rice_line_logo.png') },
        { imgSrc: require('@/assets/uupay/images/meet_nuddle_logo.png') },
        { imgSrc: require('@/assets/uupay/images/three_bro_logo.png') },
        { imgSrc: require('@/assets/uupay/images/hua_yu_jie_logo.png') },
        { imgSrc: require('@/assets/uupay/images/tai_xing_logo.png') },
        { imgSrc: require('@/assets/uupay/images/lips_tea_logo.png') },
      ]
    }
  },
  methods: {
    initSwiper() {
      this.swiperInstance = new Swiper('.horizontal-swiper-container', {
        direction: 'horizontal', // 水平方向(默认值，可省略)
        slidesPerView: 6,       // 同时显示的幻灯片数量
        spaceBetween: 30,       // 幻灯片间距
        loop: false,             // 循环模式
        centeredSlides: false,   // 活动幻灯片居中
        autoplay: {             // 自动播放
          delay: 2500,
          disableOnInteraction: false
        },
        pagination: {           // 分页器
          el: '.swiper-pagination',
          clickable: true
        },
        breakpoints: {         // 响应式断点
          640: {
            slidesPerView: 1
          },
          768: {
            slidesPerView: 2
          },
          1024: {
            slidesPerView: 3
          },
          1440: {
            slidesPerView: 6
          }
        }
      })
    }
  },
  beforeDestroy() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true)
    }
  },
  mounted() {
    this.initSwiper()
  }
}
</script>
<style scoped>
.partners-section {
  padding: 4rem 0;
  font-size: 22px;
  line-height: 30px;
  color: #21042e;
}

.partner-icon {
  width: auto;
  height: 80px;
  margin: 0 10px;
}

.horizontal-swiper-container {
  width: 100%;
  margin: 20px auto;
}

.swiper-slide {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;

}
</style>


// WEBPACK FOOTER //
// src/components/uupayMerchant.vue